import { render, staticRenderFns } from "./LevelEdit.vue?vue&type=template&id=03c5ffbd&scoped=true&"
import script from "./LevelEdit.vue?vue&type=script&lang=js&"
export * from "./LevelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5ffbd",
  null
  
)

export default component.exports